export default __webpack_public_path__ + "static/media/calendar.2f12f6f9.png";